import {AbstractModel, JsonObject, JsonProperty, DateConverter, DateOnlyConverter} from 'projects/core/src/public-api';
import { ShortObject } from 'projects/app-misc/src/app/modules/project-misc/data/project/short-json-object';
import { ShortProject } from 'projects/app-misc/src/app/modules/project-misc/data/project/short-project';
import { TrelloCheckItem } from 'projects/app-misc/src/app/modules/trello-misc/data/trello-check-item';
import { ClientNotification } from 'projects/desktop/src/app/view/notification/client-nfs-page/data/client-nfs';
import { ProjectFile } from '../../../../../../../app-misc/src/app/modules/project-misc/data/project/project-file';

@JsonObject('model.Task')
export class Task extends AbstractModel {

  @JsonProperty(Number, 'id')
  id?: number;

  @JsonProperty(Number, 'entityId')
  entityId?: number;

  @JsonProperty(Number, 'number')
  number?: number;

  @JsonProperty(String, 'clazz')
  clazz?: string;

  @JsonProperty(ShortObject, 'assignedUser')
  assignedUser?: ShortObject;

  @JsonProperty(ShortObject, 'author')
  author?: ShortObject;

  @JsonProperty([Number], 'photoIds')
  photoIds?: number[];

  @JsonProperty(Boolean, 'hasFiles')
  hasFiles?: boolean;

  @JsonProperty(DateConverter, 'completed')
  completed?: Date;

  @JsonProperty(DateConverter, 'created')
  created?: Date;

  @JsonProperty(DateConverter, 'lastUpdatedDate')
  lastUpdatedDate?: Date;

  @JsonProperty([TrelloCheckItem], 'checkitems')
  checkitems?: TrelloCheckItem[];

  @JsonProperty([Number], 'checkitemIds')
  checkitemIds?: number[];

  @JsonProperty(DateOnlyConverter, 'deadline')
  deadline?: Date;

  @JsonProperty(String, 'text')
  text?: string;

  @JsonProperty(String, 'deliveryInstructions')
  deliveryInstructions?: string;

  @JsonProperty(DateConverter, 'confirmedDate')
  confirmedDate?: Date;

  @JsonProperty(ShortProject, 'project')
  project?: ShortProject;

  @JsonProperty(Number, 'totalComments')
  totalComments?: number;

  @JsonProperty(Number, 'unreadComments')
  unreadComments?: number;

  @JsonProperty(Number, 'checkitemsTotal')
  checkitemsTotal?: number;

  @JsonProperty(Number, 'checkitemsCompleted')
  checkitemsCompleted?: number;

  @JsonProperty([ClientNotification], 'clientNotifications')
  clientNotifications?: ClientNotification[];

  @JsonProperty([ProjectFile], 'files')
  files?: ProjectFile[] = [];

  @JsonProperty(Boolean, 'isSample')
  isSample?: boolean;

  @JsonProperty(Boolean, 'isLock')
  isLock?: boolean;

  @JsonProperty(Boolean, 'isWorkOnSite')
  isWorkOnSite?: boolean;

  @JsonProperty(String, 'createdByTagName')
  createdByTagName?: string;

}
